import { defineComponent } from "vue";
import TuiButton from "../../common/base/Button.vue.mjs";
import Select from "../../common/base/Select/index.mjs";
import OPtion from "../../common/base/Option/index.mjs";
import Dialog from "../../common/base/Dialog/index.mjs";
import { TUIRole } from "@tencentcloud/tuiroom-engine-js";
import useEndControl from "./useEndControlHooks.mjs";
import logger from "../../../utils/common/logger/index.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "../../../locales/index.mjs";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "EndControlPC",
  setup(__props) {
    const {
      t,
      roomStore,
      roomEngine,
      stopMeeting,
      cancel,
      selectedUser,
      DialogType,
      showEndDialogContent,
      logPrefix,
      title,
      showEndButtonContent,
      currentDialogType,
      visible,
      resetState,
      isMasterWithOneRemoteUser,
      isMasterWithRemoteUser,
      remoteEnteredUserList
    } = useEndControl();
    function handleEndBtnClick() {
      stopMeeting();
    }
    function handleEndLeaveClick() {
      if (!roomStore.isMaster || roomStore.isMaster && remoteEnteredUserList.value.length === 0) {
        leaveRoom();
        return;
      }
      if (isMasterWithRemoteUser.value) {
        selectedUser.value = remoteEnteredUserList.value[0].userId;
        if (isMasterWithOneRemoteUser.value) {
          transferAndLeave();
          return;
        }
        currentDialogType.value = DialogType.TransferDialog;
      }
    }
    async function dismissRoom() {
      try {
        logger.log(`${logPrefix}dismissRoom: enter`);
        resetState();
        await roomService.dismissRoom();
      } catch (error) {
        logger.error(`${logPrefix}dismissRoom error:`, error);
      }
    }
    async function leaveRoom() {
      try {
        resetState();
        await roomService.leaveRoom();
      } catch (error) {
        logger.error(`${logPrefix}leaveRoom error:`, error);
      }
    }
    async function transferAndLeave() {
      var _a;
      if (!selectedUser.value) {
        return;
      }
      try {
        const userId = selectedUser.value;
        const changeUserRoleResponse = await ((_a = roomEngine.instance) == null ? void 0 : _a.changeUserRole({
          userId,
          userRole: TUIRole.kRoomOwner
        }));
        logger.log(`${logPrefix}transferAndLeave:`, changeUserRoleResponse);
        resetState();
        await roomService.leaveRoom();
      } catch (error) {
        logger.error(`${logPrefix}transferAndLeave error:`, error);
      }
    }
    return { __sfc: true, t, roomStore, roomEngine, stopMeeting, cancel, selectedUser, DialogType, showEndDialogContent, logPrefix, title, showEndButtonContent, currentDialogType, visible, resetState, isMasterWithOneRemoteUser, isMasterWithRemoteUser, remoteEnteredUserList, handleEndBtnClick, handleEndLeaveClick, dismissRoom, leaveRoom, transferAndLeave, TuiButton, TuiSelect: Select, TuiOption: OPtion, Dialog };
  }
});
export {
  _sfc_main as default
};
